/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance,{ axiosInstance9000 } from "../api/axiosInstance";

export const fetchStatusPolicy = createAsyncThunk(
  "statusPolicy/fetchStatusPolicy",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance9000.get("/api/insured/my/policy/count");
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.repsonse?.data || err.message);
    }
  }
);

const statusPolicyReducer = createSlice({
  name: "statusPolicy",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(statusPolicyReducer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(statusPolicyReducer.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(statusPolicyReducer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default statusPolicyReducer;
